module.exports = __webpack_public_path__ + "static/media/ancianos.bd91bac7.webp";